import {RouletteWinPrizeTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteWinPrizeTypeVo.enum';
import {RouletteWinPrizeType} from '../generated/types';

export function createRoulettePrizeType(type = RouletteWinPrizeTypeVo.Cash) {
  return WIN_PRIZE_TYPE_MAP[type];
}

const WIN_PRIZE_TYPE_MAP = {
  [RouletteWinPrizeTypeVo.Cash]: RouletteWinPrizeType.Cash,
  [RouletteWinPrizeTypeVo.Goods]: RouletteWinPrizeType.Goods,
  [RouletteWinPrizeTypeVo.Ticket]: RouletteWinPrizeType.Ticket,
};
